<script setup lang="ts">
import { computed } from 'vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import NavbarMoneyImage from '@/components/navbar-icons/NavbarMoneyImage.vue'
import { useSpecialCollectibleChallenge } from '@/composables/game/challenges'
import { SPECIAL_CURRENCY_ID } from '@/types/shared/player'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  hide: []
}>()

const { currencyImage, specialCollectibleChallengeCurrency } = useSpecialCollectibleChallenge()

const isHolidayOrb = computed(() => specialCollectibleChallengeCurrency.value === SPECIAL_CURRENCY_ID.HOLIDAY_ORB)
const collectibleName = computed(() => isHolidayOrb.value ? 'Holiday Orbs' : 'DropKeys')

function handleClose() {
  emit('hide')
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    wrapper-class="z-[801]"
    :centered="true"
    @hide="handleClose"
  >
    <div class="w-full flex flex-col gap-y-3">
      <h2 class="text-solid-white text-lg font-bold mb-1">
        <T
          key-name="collectible_challenge.rules.title"
          default-value="How it works?"
        />
      </h2>

      <div class="flex items-center gap-x-2">
        <div class="flex-shrink-0">
          <img
            v-if="currencyImage"
            :src="currencyImage"
            class="size-8"
            alt="DropKey"
          >
        </div>
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">Collect</span>
            {{ ` as many of ${collectibleName} as you can before time runs out.` }}
          </p>
        </div>
      </div>

      <div class="flex items-center gap-x-4">
        <div class="flex-shrink-0">
          <NavbarMoneyImage class="size-6" />
        </div>
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">
              <T
                key-name="collectible_challenge.rules.wallet.title"
                default-value="Only"
              />
            </span>
            <T
              key-name="collectible_challenge.rules.wallet.description"
              default-value=" connected wallets will receive rewards."
            />
          </p>
        </div>
      </div>

      <BaseButton
        class="w-full mt-3"
        style-type="tertiary"
        button-class="h-14 text-lg font-bold uppercase tracking-wider"
        @click="handleClose"
      >
        <T
          key-name="collectible_challenge.rules.got_it"
          default-value="GOT IT"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
</style>